export default __webpack_public_path__ + "static/media/vf-attachment-deleted.dda81bbd.svg";